<template>
  <div
    class="background-surface border-radius-8 border--solid border--complementary-50"
  >
    <b-row v-if="itemsFiltered.length || loading" class="margin-0 padding-y-24">
      <b-col
        v-if="!loading"
        cols="12"
        class="padding-x-16 font-size-14 color-complementary-400 margin-bottom-20 flex-between"
      >
        <span>
          {{ $lang.addTermStates }}
        </span>
        <Button
          wrapperClass="flex-center width-28"
          justIcon="plus"
          contentClass="justify-content-center"
          variant="primary"
          size="sm"
          @click="handleOpenAddPin"
        />
      </b-col>
      <b-col class="padding-0">
        <Loading :loading="loading">
          <template>
            <LazyLoadingWrapper
              class="height--100vh--241 w-100 overflow-y-auto padding-x-16"
              :loading="loadMoreLoading"
              :loadMore="loadMore"
              :isEmpty="firstLoaded && !itemsFiltered.length && !loading"
              :emptyImage="$config.images.shared.redesign.empty.history"
              :emptyText="$lang.history_empty_text"
              scrollDistance="700"
            >
              <template>
                <div
                  v-for="(item, index) in itemsFiltered"
                  :key="`a-${index}`"
                  class="border--solid border--complementary-50 border-radius-8 padding-8 margin-bottom-8 flex-between"
                >
                  <div>
                    <div class="flex margin-bottom-12">
                      <span
                        class="color-complementary-400 font-size-14 margin-left-8"
                      >
                        {{ item.caption }}
                      </span>
                      <span
                        :class="`chips chips--${
                          item.isEnable ? 'success' : 'error-light'
                        }`"
                      >
                        {{ item.isEnable ? "فعال" : "غیر فعال" }}
                      </span>
                    </div>
                    <div class="color-complementary-300 font-size-12">
                      {{
                        `${$lang.executeExpire}: ${item.maxDayStatusCompleted} ${$lang.day}`
                      }}
                    </div>
                  </div>
                  <div
                    class="flex flex-direction-column color-complementary-300 font-size-12"
                  >
                    <div
                      class="flex-end color-complementary-200 margin-bottom-16"
                    >
                      <span
                        class="margin-left-8 cursor--pointer"
                        @click="handleOpenRemoveModal(item.code)"
                      >
                        <mdicon name="trash-can-outline" size="24" />
                      </span>
                      <span
                        class="cursor--pointer"
                        @click="handleOpenEditPin(item.code)"
                      >
                        <mdicon name="pencil-outline" size="24" />
                      </span>
                    </div>
                    <div class="margin-bottom-8">
                      {{ `${$lang.start}: `
                      }}<span v-html="item.startDate"></span>
                    </div>
                    <div>
                      {{ `${$lang.end}: ` }}<span v-html="item.endDate"></span>
                    </div>
                  </div>
                </div>
              </template>
            </LazyLoadingWrapper>
          </template>
        </Loading>
      </b-col>
    </b-row>
    <b-row
      v-if="!itemsFiltered.length && !loading"
      class="margin-0 padding-x-16 padding-y-24"
    >
      <b-col
        cols="12"
        class="border--dashed border--complementary-100 border-radius-8 padding-y-32 flex-center flex-direction-column"
      >
        <div class="font-size-14 color-complementary-300 margin-bottom-16">
          {{ $lang.clickForAddTermState }}
        </div>
        <Button
          rightIcon="plus"
          variant="complementary"
          :text="$lang.newLevel"
          @click="handleOpenAddPin"
        />
      </b-col>
    </b-row>
    <Modal
      :show="isRemoveModal"
      :title="$lang.removeRegisterCode"
      :closeOnBackdrop="false"
      :hasClose="false"
      :okButton="true"
      :okButtonText="$lang.remove"
      okButtonVariant="filled-error"
      size="sm"
      :okLoading="removeLoading"
      :ok="handleRemove"
      @close="handleCloseRemoveModal"
    >
      <template #body>
        <div class="margin-bottom-24 font-size-14 color-complementary-300">
          {{ $lang.remove_sure_message.replace("{0}", $lang.termState) }}
        </div>
      </template>
    </Modal>
    <AddTermStatePin
      :visible="isAddPin"
      @handleClose="handleCloseAddPin"
      @handleFetchData="fetchData"
    />
    <EditTermStatePin
      :visible="isEditPin"
      :termStateCode="termStateCode"
      @handleClose="handleCloseEditPin"
      @handleFetchData="fetchData"
    />
  </div>
</template>

<script>
import LazyLoadingWrapper from "@/components/re-design/lazy-loading-wrapper/LazyLoadingWrapper.vue";
import { Button } from "@/components/re-design/forms";
import Modal from "@/components/re-design/modal/Modal.vue";
import Loading from "./Loading.vue";
import AddTermStatePin from "./AddTermStatePin.vue";
import EditTermStatePin from "./EditTermStatePin.vue";
import { pathOr } from "ramda";
import { computed, inject, onMounted, ref } from "vue";
import { getAllTermState, removeTermState } from "@/modules/profile/services";
import { createDateFormat, generateError, toastAlert } from "@/shared/utils";
export default {
  components: {
    LazyLoadingWrapper,
    Loading,
    Button,
    Modal,
    AddTermStatePin,
    EditTermStatePin,
  },

  setup() {
    // generate items
    const termCode = inject("TERM_CODE");
    const firstLoaded = ref(false);
    const loading = ref(false);
    const loadMoreLoading = ref(false);
    const paging = ref({
      total: 0,
      count: 0,
      totalPages: 0,
      currentPage: 1,
      perPage: 20,
    });
    const termStateItems = ref([]);
    const getItems = async () => {
      try {
        const response = await getAllTermState(
          termCode,
          paging.value.currentPage,
          paging.value.perPage
        );

        const { total, count, totalPages, currentPage, perPage, items } =
          response;
        paging.value = {
          total,
          count,
          totalPages,
          currentPage,
          perPage,
        };
        return items;
      } catch (error) {
        generateError(error);
      }
    };
    const fetchData = async () => {
      try {
        paging.value = {
          total: 0,
          count: 0,
          totalPages: 0,
          currentPage: 1,
          perPage: 20,
        };
        loading.value = true;
        const items = await getItems();
        termStateItems.value = [...items];
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
        firstLoaded.value = true;
      }
    };
    const loadMore = async () => {
      // load more data and pushed to list
      if (!firstLoaded.value) return;
      if (loading.value || loadMoreLoading.value) return;
      if (paging.value.currentPage >= paging.value.totalPages) return;

      try {
        loadMoreLoading.value = true;
        paging.value.currentPage = paging.value.currentPage + 1;
        const newItems = await getItems();
        termStateItems.value = [...termStateItems.value, ...newItems];
      } catch (error) {
        generateError(error);
      } finally {
        loadMoreLoading.value = false;
      }
    };
    const itemsFiltered = computed(() => {
      return termStateItems.value.map((row) => {
        const code = pathOr(null, ["code"], row);
        const caption = pathOr("", ["state_caption"], row);
        const startDate = createDateFormat(
          pathOr("", ["start_date", "jalali"], row)
        );
        const endDate = createDateFormat(
          pathOr("", ["end_date", "jalali"], row)
        );
        const maxDayStatusCompleted = pathOr(
          0,
          ["max_day_status_completed"],
          row
        );
        const isEnable = pathOr(false, ["is_enable"], row);
        return {
          code,
          caption,
          startDate,
          endDate,
          maxDayStatusCompleted,
          isEnable,
        };
      });
    });

    // fetched data when mounted component
    onMounted(() => fetchData());

    const termStateCode = ref(null);
    // remove an item
    const isRemoveModal = ref(false);
    const removeLoading = ref(false);
    const handleOpenRemoveModal = (code) => {
      termStateCode.value = code;
      isRemoveModal.value = true;
    };
    const handleCloseRemoveModal = () => (isRemoveModal.value = false);
    const handleRemove = async () => {
      try {
        removeLoading.value = true;
        const id = termStateCode.value;
        const response = await removeTermState(termCode, id);
        const { message } = response;
        toastAlert(message);
        handleCloseRemoveModal();
        fetchData();
      } catch (error) {
        generateError(error);
      } finally {
        removeLoading.value = false;
      }
    };

    const isAddPin = ref(false);
    const handleCloseAddPin = () => (isAddPin.value = false);
    const isEditPin = ref(false);
    const handleCloseEditPin = () => (isEditPin.value = false);

    const handleOpenAddPin = () => {
      handleCloseEditPin();
      isAddPin.value = true;
    };

    const handleOpenEditPin = (code) => {
      termStateCode.value = code;
      handleCloseAddPin();
      isEditPin.value = true;
    };

    // return data to be used in template
    return {
      firstLoaded,
      loading,
      loadMoreLoading,
      itemsFiltered,
      isRemoveModal,
      removeLoading,
      isAddPin,
      isEditPin,
      termStateCode,
      loadMore,
      handleOpenRemoveModal,
      handleCloseRemoveModal,
      handleRemove,
      handleOpenAddPin,
      handleCloseAddPin,
      handleOpenEditPin,
      handleCloseEditPin,
      fetchData,
    };
  },
};
</script>
